export default __webpack_public_path__ + "static/media/flanges.35112661.webp";